import { Component, Input, inject } from '@angular/core';
import { remove } from 'lodash-es';
import { Capture } from '../../../core/models/capture.model';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { CaptureValidationService, ValidationKeys } from '../../../core/services/capture-validation.service';
import { SpecialistEncounterVerification } from '../../../core/models/specialist-encounter-verification.model';
import { CaptureService } from '../../../core/services/capture.service';
import { PatientAttachmentsService } from '../../../core/services/patient-attachments.service';
import { SpecialistEncounterVerificationsComponent } from '../specialist-encounter-verifications/specialist-encounter-verifications.component';
import { VerificationValidationComponent } from '../verification-validation/verification-validation.component';

@Component({
  selector: 'app-specialist-encounter-form',
  templateUrl: './specialist-encounter-form.component.html',
  styleUrls: ['./specialist-encounter-form.component.scss'],
  imports: [SpecialistEncounterVerificationsComponent, VerificationValidationComponent]
})
export class SpecialistEncounterFormComponent {
  private authService = inject(AuthenticationService);
  private captureService = inject(CaptureService);
  private patientAttachmentsService = inject(PatientAttachmentsService);
  private captureValidationService = inject(CaptureValidationService);

  @Input() capture: Capture;
  @Input() patientAttachment: PatientAttachment;

  validationKey = ValidationKeys.specialistEncounterVerification;

  onVerificationChange(change: { verification: SpecialistEncounterVerification; tempId?: string }) {
    this.captureValidationService.clearError(this.validationKey);
    this.updateCaptureSpecialistEncounterVerification(change.verification, change.tempId);
  }

  onVerificationRemove(sev: SpecialistEncounterVerification) {
    this.captureValidationService.clearError(this.validationKey);
    this.removeCaptureSpecialistEncounterVerification(sev);
  }

  private updateCaptureSpecialistEncounterVerification(
    specialistEncounterVerification: SpecialistEncounterVerification,
    tempId?: string
  ) {
    const modifiedPatientAttachment: PatientAttachment = Object.assign({}, this.patientAttachment);

    if (!modifiedPatientAttachment.specialistEncounterVerifications) {
      modifiedPatientAttachment.specialistEncounterVerifications = [];
    }

    const paIndex = modifiedPatientAttachment.specialistEncounterVerifications.findIndex(
      paSev => paSev.id === specialistEncounterVerification.id || paSev.id === tempId
    );

    if (paIndex > -1) {
      modifiedPatientAttachment.specialistEncounterVerifications[paIndex] = specialistEncounterVerification;
    } else {
      modifiedPatientAttachment.specialistEncounterVerifications.push(specialistEncounterVerification);
    }

    this.patientAttachmentsService.notifyPatientAttachmentChanged(modifiedPatientAttachment);
  }

  private removeCaptureSpecialistEncounterVerification(sev: SpecialistEncounterVerification) {
    const modifiedPatientAttachment: PatientAttachment = Object.assign({}, this.patientAttachment);
    remove(modifiedPatientAttachment.specialistEncounterVerifications, captureSev => captureSev.id === sev.id);
    this.patientAttachmentsService.notifyPatientAttachmentChanged(modifiedPatientAttachment);
  }
}
